/**
 * Regulators Badge — Display CNSF and Condusef as oversight authorities.
 * Placed before the Optimaxx Plus product section to establish trust.
 */
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import './RegulatorsBadge.css';

const CONDUSEF_LOGO = 'https://customer-assets.emergentagent.com/job_ahorro-constante/artifacts/xwwwo5q2_condusef.png';
const CNSF_LOGO = 'https://customer-assets.emergentagent.com/job_ahorro-constante/artifacts/19evgy36_short_cnfs_ok.png';

const RegulatorsBadge = () => {
  return (
    <div className="regulators-badge" data-testid="regulators-badge">
      <div className="regulators-header">
        <ShieldCheck className="regulators-icon" />
        <span className="regulators-label">Productos regulados y supervisados por</span>
      </div>
      <div className="regulators-logos">
        <div className="regulator-item">
          <img
            src={CNSF_LOGO}
            alt="CNSF — Comisión Nacional de Seguros y Fianzas"
            className="regulator-logo"
            loading="lazy"
          />
          <span className="regulator-name">CNSF</span>
          <span className="regulator-fullname">Comisión Nacional de Seguros y Fianzas</span>
        </div>
        <div className="regulator-divider" aria-hidden="true" />
        <div className="regulator-item">
          <img
            src={CONDUSEF_LOGO}
            alt="Condusef — Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros"
            className="regulator-logo"
            loading="lazy"
          />
          <span className="regulator-name">Condusef</span>
          <span className="regulator-fullname">Defensa de los usuarios de servicios financieros</span>
        </div>
      </div>
    </div>
  );
};

export default RegulatorsBadge;
